import { render, staticRenderFns } from "./VoilaImageWithoutWireframe.vue?vue&type=template&id=7bd728dc&"
import script from "./VoilaImageWithoutWireframe.vue?vue&type=script&lang=js&"
export * from "./VoilaImageWithoutWireframe.vue?vue&type=script&lang=js&"
import style0 from "./VoilaImageWithoutWireframe.vue?vue&type=style&index=0&id=7bd728dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports